// VÉLIS - Contenu extrait du design Canva (frontend only, données mockées)

export const brand = {
  name: "VÉLIS",
  tagline: "GARDEZ LE CAP",
  motto: "Là où vos actions prennent de la valeur.",
};

// Liens fonctionnels (placeholders — à remplacer par les vraies URL)
export const links = {
  appStore: "https://apps.apple.com/",
  googlePlay: "https://play.google.com/",
  support: "mailto:support@velisproductivity.com",
  supportEmail: "support@velisproductivity.com",
  privacy: "/confidentialite",
  terms: "/conditions",
  supportPage: "/support",
  social: {
    tiktok: "https://tiktok.com/",
    x: "https://x.com/",
    facebook: "https://www.facebook.com/profile.php?id=61593220480261",
  },
};

// Section 1 — Hero
export const hero = {
  title: "Là où vos actions",
  titleAccent: "prennent de la valeur.",
  subtitle:
    "Organisez vos priorités, avancez dans vos projets et voyez votre progression prendre forme.",
  image: "/images/home-screen-updated.png",
  background: "/images/mountain-sunset.jpg",
};

// Section 2 — Vos actions. Votre progression.
export const features = {
  title: "Vos actions. Votre progression.",
  subtitle:
    "Capturez ce que vous avez à faire, choisissez ce qui compte et voyez votre progression prendre forme.",
  image: "/images/missions-screen-updated.png",
  items: [
    {
      icon: "Zap",
      title: "Capturez rapidement",
      text: "Ajoutez vos missions en quelques secondes, sans interrompre votre élan.",
    },
    {
      icon: "Star",
      title: "Choisissez vos priorités",
      text: "Gardez sous les yeux ce qui compte vraiment aujourd’hui.",
    },
    {
      icon: "TrendingUp",
      title: "Progressez concrètement",
      text: "Chaque action accomplie fait avancer vos objectifs.",
    },
  ],
};

// Section 3 — Transformez vos objectifs en expéditions.
export const expeditions = {
  title: "Transformez vos objectifs en expéditions.",
  subtitle:
    "Voyez où vous allez, ce que vous avez accompli et jusqu’où vos actions vous ont fait progresser.",
  image: "/images/expeditions-screen-updated.png",
  items: [
    { icon: "Compass", title: "Un objectif clair", time: "10:02" },
    { icon: "CheckCircle2", title: "Des missions accomplies", time: "10:04" },
    { icon: "LineChart", title: "Une progression visible", time: "10:06" },
  ],
};

// Section 4 — Capturez vos missions. Organisez-les ensuite.
export const capture = {
  title: "Capturez vos missions. Organisez-les ensuite.",
  subtitle:
    "Ajoutez rapidement ce que vous avez à faire, puis choisissez ce qui mérite votre attention aujourd’hui.",
  image: "/images/missions-screen-updated.png",
  items: [
    { icon: "Pencil", title: "Ajoutez en rafale" },
    { icon: "Star", title: "Choisissez vos priorités" },
    { icon: "Check", title: "Avancez une mission à la fois" },
  ],
};

// Section 5 — CTA / Footer
export const footer = {
  title: "Gardez le cap sur ce qui compte.",
  subtitle: "Transformez vos actions quotidiennes en progression visible.",
  motto: "Là où vos actions prennent de la valeur.",
  email: "support@velisproductivity.com",
};
